import axios from "axios";
import authHeader from "./auth-header";

const API_URL = `${process.env.VUE_APP_API_ENDPOINT}/api/category`;

class CategoryService {
  get() {
    return axios.get(`${API_URL}/list`, {
      headers: authHeader(),
    });
  }
  find(id) {
    return axios.get(`${API_URL}/item/${id}`, {
      headers: authHeader(),
    });
  }
}

export default new CategoryService();
